import React from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import { styled } from "@mui/system";

const StyledLoaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 20px",
  width: "100%",
  minHeight: "300px",
  gap: "20px",
}));

const MessageCard = styled(Paper)(({ theme }) => ({
  padding: "12px 24px",
  borderRadius: "12px",
  backgroundColor: "rgba(114, 133, 179, 0.08)",
  border: "1px solid rgba(114, 133, 179, 0.2)",
  boxShadow: "none",
}));

export const LoadingScreen = ({ message = "Loading data...", size = 50 }) => {
  return (
    <StyledLoaderContainer>
      <CircularProgress 
        size={size} 
        thickness={4} 
        sx={{ 
          color: "#7285b3",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          }
        }} 
      />
      {message && (
        <MessageCard elevation={0}>
          <Typography 
            variant="body1" 
            sx={{ 
              color: "#5a6a94", 
              fontWeight: 500, 
              fontFamily: "Poppins, sans-serif",
              letterSpacing: "0.5px"
            }}
          >
            {message}
          </Typography>
        </MessageCard>
      )}
    </StyledLoaderContainer>
  );
};

export default LoadingScreen;
